import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid, IonIcon,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
  IonLoading,
  IonPage,
  IonRange,
  IonRow,
  IonText,
  IonTitle,
  IonToast,
  IonToolbar,
} from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CountUp from "react-countup";
import { AuthContext } from "../../providers/authContext";
import Header from "../components/Header";
import { AskidaFaturaIstatistik } from "../entities/AskidaFaturaIstatistik";
import { AskidaYardimDetay } from "../entities/AskidaYardimDetay";
import Tahsilat from "../entities/tahsilat";
import {
  CARD_ENROLLMENT_URL,
  TAHSILAT_BASARILI,
  TAHSILAT_BASARISIZ,
  HASH_URL,
} from "../services/constants";
import sorgulamaService from "../services/SorgulamaService";
import tahsilatService from "../services/TahsilatService";
import Card from "../../ebelediye/entities/CardInfo";
import {arrowBack, card} from "ionicons/icons";
import Cards, {Focused} from "react-credit-cards";
import {InputMask} from "primereact/inputmask";
import {InputText} from "primereact/inputtext";

const AnneBebekPaketi: React.FC = () => {
  const { logo, kurumBilgileri } = React.useContext(AuthContext);
  const contentRef = useRef<HTMLIonContentElement>(null);
  const paymentFormRef = useRef<HTMLFormElement>(null);
  const [creditCard, setCreditCard] = useState<Card>(new Card());
  const [slidesMainIndex, setSlidesMainIndex] = useState(0);
  const [showLoading, setShowLoading] = useState<boolean>(true);
  const [showToastMessage, setShowToastMessage] = useState<string>();
  const [tahsilat, setTahsilat] = useState<Tahsilat>();
  const [rangeValue, setRangeValue] = useState<{
    lower: number;
    upper: number;
  }>({ lower: 0, upper: 2000 });
  const [paketler, setPaketler] = useState<AskidaYardimDetay[]>([]);
  const [ilkPaketler, setIlkPaketler] = useState<AskidaYardimDetay[]>([]);
  const [paket, setPaket] = useState<AskidaYardimDetay>();
  const [istatistik, setIstatistik] = useState<AskidaFaturaIstatistik>(
    new AskidaFaturaIstatistik(0, 0, 0)
  );

  React.useEffect(() => {
    setSlidesMainIndex(0);
    sorgulamaService
      .getAnneBebekPaketleri()
      .then((data) => {
        const sorted = data.sort(
          (p: AskidaYardimDetay, v: AskidaYardimDetay) => p.tutar - v.tutar
        );
        setIlkPaketler(sorted);
        setPaketler(sorted);
      })
      .catch((err) => {
        console.error(err);
        setShowToastMessage(err);
      })
      .finally(() => setShowLoading(false));

    sorgulamaService
      .getAskidaYardimIstatistik(5)
      .then((data) => setIstatistik(data))
      .catch((err) => {
        console.error(err.response);
        setShowToastMessage(err.message);
      });
  }, []);

  useEffect(() => {
    setPaketler(
      ilkPaketler.filter(
        (a) => a.tutar > rangeValue.lower && a.tutar < rangeValue.upper
      )
    );
  }, [rangeValue]);

  const formatCurrency = (value: number | undefined) => {
    if (!value) {
      value = 0;
    }
    return new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 2,
    }).format(value);
  };

  const goBack = () => {
    setPaket(undefined);
    setSlidesMainIndex(0);
  };

  const goForward = async (a: AskidaYardimDetay) => {
    setPaket(a);
    setSlidesMainIndex(1);
  }

  const postPaymentInfo = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setShowLoading(true);
    tahsilatService
      .askidaTahsilatHazirla(paket!.id, paket!.tutar, true)
      .then(async (data: Tahsilat) => {
        setTahsilat(data);
        await contentRef.current?.scrollToTop();

        const year = creditCard.expiry.slice(2);
        const month = creditCard.expiry.slice(0, 2);
        if (kurumBilgileri?.banka === "payflex") {
          let $xml = '';
          $xml += '<VposRequest>';
          $xml += '<MerchantId>' + kurumBilgileri?.eBelediyeClientId + '</MerchantId>';
          $xml += '<HashData>' + data.hash + '</HashData>';
          $xml += '<OrderId>' + data.oid + '</OrderId>';
          $xml += '<TransactionType>Sale</TransactionType>';
          $xml += '<Pan>' + creditCard.cardNo + '</Pan>';
          $xml += '<Expiry>20' + year + month + '</Expiry>';
          $xml += '<Cvv>' + creditCard.cvc + '</Cvv>';
          $xml += '<CurrencyAmount>' + paket!.tutar.toFixed(2) + '</CurrencyAmount>';
          $xml += '<CurrencyCode>949</CurrencyCode>';

          const ipResponse = await fetch('https://api.ipify.org?format=json');

          // Check if the response is successful
          if (!ipResponse.ok) {
            throw new Error('Failed to fetch IP');
          }
          const ipData = await ipResponse.json();

          $xml += '<ClientIp>' + ipData.ip + '</ClientIp>';
          $xml += '<SuccessUrl>' + TAHSILAT_BASARILI + '/true/' + data.oid + '</SuccessUrl>';
          $xml += '<FailUrl>' + TAHSILAT_BASARISIZ + '/true</FailUrl>';
          $xml += '<StoreType>' + kurumBilgileri?.sanalPosTip + '</StoreType>';
          $xml += '<TransactionDeviceSource>0</TransactionDeviceSource>';
          $xml += '<NumberOfInstallments>1</NumberOfInstallments>';
          $xml += '<Location>1</Location>';
          $xml += '<MerchantType>1</MerchantType>';
          $xml += '<CardHoldersName>' + creditCard.name + '</CardHoldersName>';
          $xml += '<BrandName>' + (creditCard.cardNo.startsWith("4") ? 100 : creditCard.cardNo.startsWith("5") ? 200 : 300) + '</BrandName>';
          $xml += '<OrderDescription>E-Belediye Borç Ödeme</OrderDescription>';
          $xml += '<Extract>Aile Paketi Yardımı</Extract>';
          $xml += '</VposRequest>';

          if (paymentFormRef.current) {
            const prmstrInput = paymentFormRef.current.querySelector('input[name="prmstr"]') as HTMLInputElement;
            if (prmstrInput) {
              prmstrInput.value = $xml;
            }
            paymentFormRef.current.submit();
          }
        } else if (kurumBilgileri?.banka === "ipay3d") {
          const params = new URLSearchParams();
          params.append('Ecom_Payment_Card_ExpDate_Month', month);
          params.append('Ecom_Payment_Card_ExpDate_Year', year);
          params.append('pan', creditCard.cardNo);
          params.append('PurchaseAmount', paket!.tutar.toFixed(2));
          params.append('oid', data.oid);
          params.append('SessionInfo', paket!.id);
          const response = await fetch(CARD_ENROLLMENT_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString()
          });
          // Check if the response is successful
          if (!response.ok) {
            throw new Error('Failed to fetch Acs data');
          }
          const acsData = await response.json();
          if (paymentFormRef.current) {
            const acsUrlInput = paymentFormRef.current.querySelector('input[name="AcsUrl"]') as HTMLInputElement;
            if (acsUrlInput) {
              acsUrlInput.value = acsData.acsUrl;
            }
            const paReqInput = paymentFormRef.current.querySelector('input[name="PaReq"]') as HTMLInputElement;
            if (paReqInput) {
              paReqInput.value = acsData.paReq;
            }
            const termUrlInput = paymentFormRef.current.querySelector('input[name="TermUrl"]') as HTMLInputElement;
            if (termUrlInput) {
              termUrlInput.value = acsData.termUrl;
            }
            const mdInput = paymentFormRef.current.querySelector('input[name="MD"]') as HTMLInputElement;
            if (mdInput) {
              mdInput.value = acsData.md;
            }
            paymentFormRef.current.action = acsData.acsUrl;
            paymentFormRef.current.submit();
          }
        } else {
          if (paymentFormRef.current) {
            const Ecom_Payment_Card_ExpDate_Month = paymentFormRef.current.querySelector('input[name="Ecom_Payment_Card_ExpDate_Month"]') as HTMLInputElement;
            Ecom_Payment_Card_ExpDate_Month.value = month;
            const Ecom_Payment_Card_ExpDate_Year = paymentFormRef.current.querySelector('input[name="Ecom_Payment_Card_ExpDate_Year"]') as HTMLInputElement;
            Ecom_Payment_Card_ExpDate_Year.value = year;
            const pan = paymentFormRef.current.querySelector('input[name="pan"]') as HTMLInputElement;
            pan.value = creditCard.cardNo;
            const rnd = paymentFormRef.current.querySelector('input[name="rnd"]') as HTMLInputElement;
            rnd.value = data.rnd;
            const oid = paymentFormRef.current.querySelector('input[name="oid"]') as HTMLInputElement;
            oid.value = data.oid;
            const amount = paymentFormRef.current.querySelector('input[name="amount"]') as HTMLInputElement;
            amount.value = paket!.tutar.toFixed(2);

            const formData = new FormData(paymentFormRef.current);
            const response = await fetch(HASH_URL, {
              method: 'POST',
              body: formData
            });

            // Check if the response is successful
            if (!response.ok) {
              throw new Error('Failed to fetch hash data');
            }

            // Parse the response JSON
            const hashdata = await response.text();
            const hash = paymentFormRef.current.querySelector('input[name="hash"]') as HTMLInputElement;
            hash.value = hashdata;

            paymentFormRef.current.submit();
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
        setShowToastMessage(
          error.response ? error.response.data.message : error
        );
      })
      .finally(() => setShowLoading(false));
  };

  return (
    <IonPage>
      <Header
        title={kurumBilgileri?.kisaTanim}
        subtitle="Derman Ol Kampanyası"
        logo={logo}
      />
      <IonContent ref={contentRef} fullscreen className="ion-text-center">
        <IonToolbar>
          <IonTitle>ASKIDAN ANNE-BEBEK DESTEK PAKETİ AL</IonTitle>
        </IonToolbar>
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={"Lütfen Bekleyin..."}
        />
        <IonToast
          isOpen={showToastMessage !== undefined}
          onDidDismiss={() => setShowToastMessage(undefined)}
          message={showToastMessage}
          duration={2000}
          position="top"
        />
        <Carousel
          selectedItem={slidesMainIndex}
          infiniteLoop={false}
          showStatus={false}
          showArrows={false}
          swipeable={false}
          showIndicators={false}
          showThumbs={false}
        >
          <div>
            <IonList>
              <IonItem>
                <IonGrid className="center">
                  <IonRow style={{ width: "80%" }}>
                    <IonCol size="12" sizeSm="6">
                      <IonCard>
                        <IonCardHeader>
                          <IonRow>
                            <IonCol size="4">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={60}
                                height={60}
                                viewBox="0 0 32 32"
                              >
                                <path
                                  d="M 16 3 C 8.832 3 3 8.832 3 16 C 3 23.168 8.832 29 16 29 C 23.168 29 29 23.168 29 16 C 29 8.832 23.168 3 16 3 z M 16 5 C 22.065 5 27 9.935 27 16 C 27 22.065 22.065 27 16 27 C 9.935 27 5 22.065 5 16 C 5 9.935 9.935 5 16 5 z M 11 12 C 8.906 12 7.390625 13.207031 7.390625 13.207031 L 8.609375 14.792969 C 8.609375 14.792969 9.6929531 14 11.001953 14 C 12.310953 14 13.392578 14.792969 13.392578 14.792969 L 14.611328 13.207031 C 14.609328 13.207031 13.094 12 11 12 z M 21 12 C 18.906 12 17.390625 13.207031 17.390625 13.207031 L 18.609375 14.792969 C 18.609375 14.792969 19.692953 14 21.001953 14 C 22.310953 14 23.392578 14.792969 23.392578 14.792969 L 24.611328 13.207031 C 24.609328 13.207031 23.094 12 21 12 z M 10.810547 19 L 9.0898438 20 C 9.2635938 20.29875 9.455 20.584668 9.6640625 20.857422 C 9.873125 21.130176 10.100547 21.389297 10.341797 21.632812 C 10.824297 22.119844 11.368438 22.545859 11.960938 22.896484 C 12.257188 23.071797 12.56375 23.228887 12.882812 23.365234 C 13.201875 23.501582 13.532344 23.616797 13.871094 23.710938 C 14.209844 23.805078 14.55875 23.87709 14.914062 23.925781 C 15.269375 23.974473 15.63125 24 16 24 C 16.36875 24 16.730625 23.974473 17.085938 23.925781 C 18.8625 23.682324 20.451953 22.850391 21.658203 21.632812 C 21.899453 21.389297 22.126875 21.130176 22.335938 20.857422 C 22.545 20.584668 22.736406 20.29875 22.910156 20 L 21.189453 19 C 20.279453 20.56625 18.695957 21.689238 16.820312 21.945312 C 16.552363 21.981895 16.27875 22 16 22 C 15.72125 22 15.447637 21.981895 15.179688 21.945312 C 14.911738 21.90873 14.649453 21.853906 14.394531 21.783203 C 13.884688 21.641797 13.403359 21.435 12.958984 21.171875 C 12.514609 20.90875 12.107188 20.589766 11.746094 20.224609 C 11.565547 20.042031 11.396621 19.846973 11.240234 19.642578 C 11.083848 19.438184 10.940547 19.22375 10.810547 19 z"
                                  fill="blue"
                                />
                              </svg>
                            </IonCol>
                            <IonCol>
                              <IonGrid>
                                <IonRow>
                                  <IonCardTitle>
                                    {istatistik.askidanAlinan}
                                  </IonCardTitle>
                                </IonRow>
                                <IonRow>
                                  <IonCardSubtitle>
                                    Adet Alınan Paket
                                  </IonCardSubtitle>
                                </IonRow>
                              </IonGrid>
                            </IonCol>
                          </IonRow>
                        </IonCardHeader>
                      </IonCard>
                    </IonCol>
                    <IonCol size="12" sizeSm="6">
                      <IonCard>
                        <IonCardHeader>
                          <IonRow>
                            <IonCol size="4">
                              <svg
                                _ngcontent-dyy-c3=""
                                aria-hidden="true"
                                className="svg-inline--fa display-4"
                                data-fa-i2svg=""
                                data-icon="li-ra-sign"
                                data-prefix="fas"
                                focusable="false"
                                role="img"
                                viewBox="0 0 384 512"
                                width={60}
                                height={60}
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  _ngcontent-dyy-c3=""
                                  d="M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
                                  fill="blue"
                                />
                              </svg>
                            </IonCol>
                            <IonCol>
                              <IonGrid>
                                <IonRow>
                                  <IonCardTitle>
                                    <CountUp
                                      end={istatistik.toplamOdenenTutar}
                                      decimals={2}
                                      decimal=","
                                    />
                                  </IonCardTitle>
                                </IonRow>
                                <IonRow>
                                  <IonCardSubtitle>
                                    Toplam Ödenen Tutar
                                  </IonCardSubtitle>
                                </IonRow>
                              </IonGrid>
                            </IonCol>
                          </IonRow>
                        </IonCardHeader>
                      </IonCard>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </IonItem>
              <IonItemDivider>
                Başlangıç & Bitiş Filtre Değerleri
              </IonItemDivider>
              <IonItem>
                <IonRange
                  pin
                  dualKnobs
                  value={rangeValue}
                  min={0}
                  max={2000}
                  step={50}
                  snaps={true}
                  onIonChange={(e) => setRangeValue(e.detail.value as any)}
                >
                  <IonLabel slot="start">
                    Başlangıç: {rangeValue.lower}
                  </IonLabel>
                  <IonLabel slot="end">Bitiş: {rangeValue.upper}</IonLabel>
                </IonRange>
              </IonItem>
              <IonCard>
                <IonGrid>
                  <IonRow>
                    {paketler.map((a, index: any) => {
                      return (
                        <IonCol key={index} size="6" sizeSm="4">
                          <IonCard
                            className="card-hover"
                            button
                            onClick={async () => goForward(a)}
                          >
                            <IonCardHeader>
                              <IonCardTitle>
                                {formatCurrency(a.tutar)}
                              </IonCardTitle>
                              <IonCardSubtitle>{a.tanim}</IonCardSubtitle>
                            </IonCardHeader>
                            <IonCardContent>
                              <IonButton>Askıdan Al</IonButton>
                            </IonCardContent>
                          </IonCard>
                        </IonCol>
                      );
                    })}
                  </IonRow>
                </IonGrid>
              </IonCard>
            </IonList>
          </div>
          <div>
            <IonGrid>
              <IonRow>
                <IonCol offset="3" size="6">

                  <IonGrid>
                    <IonRow>
                      <IonCol>
                        <IonItem color="light">
                          <IonIcon icon={card} slot="start"/>
                          <IonLabel className="ion-text-wrap">
                            Kredi Kartı Bilgilerinizi aşağıya girip ödemeyi tamamlayabilirsiniz.
                          </IonLabel>
                        </IonItem></IonCol>
                    </IonRow>
                    <IonRow>
                      <IonCol size="3">
                        <Cards
                          cvc={creditCard.cvc}
                          expiry={creditCard.expiry}
                          focused={creditCard.focus}
                          name={creditCard.name}
                          number={creditCard.cardNo}
                          placeholders={{name: 'ADI SOYADI'}}
                        />
                      </IonCol>
                      <IonCol size="9">
                        <form id="paymentInfoForm" name="paymentInfoForm" method="post"
                              action={kurumBilgileri?.sanalPosUrl} onSubmit={(e) => postPaymentInfo(e)}>
                          <IonRow>
                            <IonCol className="ion-text-end">
                              <IonText>
                                Kredi Kartı Numarası
                              </IonText></IonCol>
                            <IonCol className="ion-text-start">
                              <input type="hidden" id="askidaFatura" name="askidaFatura"/>

                              <InputMask
                                id="number" slotChar="-" unmask
                                name="number" value={creditCard.cardNo}
                                onFocus={(e) => setCreditCard({...creditCard, focus: e.target.name as Focused})}
                                onChange={(e) => setCreditCard({...creditCard, cardNo: e.value})}
                                mask="9999 9999 9999 9999"/>
                            </IonCol>
                          </IonRow>
                          <IonRow>
                            <IonCol className="ion-text-end">
                              <IonText>
                                Adı Soyadı
                              </IonText></IonCol>
                            <IonCol className="ion-text-start">
                              <InputText
                                id="name"
                                name="name" value={creditCard.name}
                                onFocus={(e) => setCreditCard({...creditCard, focus: e.target.name as Focused})}
                                onChange={(e) => setCreditCard({...creditCard, name: e.target.value})}/>
                            </IonCol>
                          </IonRow>
                          <IonRow>
                            <IonCol className="ion-text-end">
                              <IonText>
                                Son Kul. Tar (MM / YY)
                              </IonText></IonCol>
                            <IonCol className="ion-text-start">
                              <InputMask
                                id="expiry" slotChar="-" unmask
                                name="expiry" value={creditCard.expiry}
                                onFocus={(e) => setCreditCard({...creditCard, focus: e.target.name as Focused})}
                                onChange={(e) => setCreditCard({...creditCard, expiry: e.value})}
                                mask="99/99"/>
                            </IonCol>
                          </IonRow>
                          <IonRow>
                            <IonCol className="ion-text-end">
                              <IonText>
                                CVC
                              </IonText></IonCol>
                            <IonCol className="ion-text-start">
                              <InputMask
                                id="cvc" slotChar="-" unmask
                                name="cvc" value={creditCard.cvc}
                                onFocus={(e) => setCreditCard({...creditCard, focus: e.target.name as Focused})}
                                onChange={(e) => setCreditCard({...creditCard, cvc: e.value})}
                                mask="999"/>
                            </IonCol>
                          </IonRow>
                        </form>

                        <form id="payflexForm" ref={paymentFormRef} method="POST" action={kurumBilgileri?.sanalPosUrl}>
                          {kurumBilgileri?.banka === "payflex" ?
                            <input type="hidden" name="prmstr" value=""/>
                            : kurumBilgileri?.banka === "ipay3d" ?
                              <>
                                <input type="hidden" id="AcsUrl" name="AcsUrl"/>
                                <input type="hidden" id="PaReq" name="PaReq"/>
                                <input type="hidden" id="TermUrl" name="TermUrl"/>
                                <input type="hidden" id="MD" name="MD"/>
                              </>
                              :
                              <>
                                <input type="hidden" id="encoding" name="encoding" value="UTF-8"/>
                                <input type="hidden" id="clientid" name="clientid"
                                       value={kurumBilgileri?.eBelediyeClientId}/>
                                <input type="hidden" id="fulkekod" name="fulkekod" value="tr"/>
                                <input type="hidden" id="lang" name="lang" value="tr"/>
                                <input type="hidden" id="currency" name="currency" value="949"/>
                                <input type="hidden" id="hashAlgorithm" name="hashAlgorithm" value="ver3"/>
                                <input type="hidden" id="refreshtime" name="refreshtime" value="5"/>
                                <input type="hidden" id="taksit" name="taksit" value=""/>
                                <input type="hidden" id="islemtipi" name="islemtipi" value="Auth"/>
                                <input type="hidden" id="rnd" name="rnd"/>
                                <input type="hidden" id="storetype" name="storetype"
                                       value={kurumBilgileri?.sanalPosTip}/>
                                <input type="hidden" id="hash" name="hash"/>
                                <input type="hidden" id="amount" name="amount"/>
                                <input type="hidden" id="oid" name="oid"/>
                                <input type="hidden" id="okUrl" name="okUrl" value={TAHSILAT_BASARILI + '/true'}/>
                                <input type="hidden" id="failUrl" name="failUrl" value={TAHSILAT_BASARISIZ + '/true'} />
                                <input type="hidden" id="name" name="name"/>
                                <input type="hidden" id="pan" name="pan"/>
                                <input type="hidden" id="Ecom_Payment_Card_ExpDate_Month"
                                       name="Ecom_Payment_Card_ExpDate_Month"/>
                                <input type="hidden" id="Ecom_Payment_Card_ExpDate_Year"
                                       name="Ecom_Payment_Card_ExpDate_Year"/>
                                <input type="hidden" id="askidaFatura" name="askidaFatura" value="false"/>
                              </>}
                        </form>
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol offset="3" size="6">
                  <IonItem>
                    <IonButton slot="start" size="default" onClick={() => goBack()}>
                      <IonIcon slot="start" icon={arrowBack}/>
                      <IonText className="ion-hide-sm-down">Geri</IonText>
                    </IonButton>
                    <IonLabel className="ion-text-end ion-padding-end">
                      <IonText className="ion-hide-sm-down">ÖDENECEK MİKTAR: </IonText>
                      <IonText className="ion-hide-sm-up">Topl.: </IonText>
                      {formatCurrency(paket?.tutar)}
                    </IonLabel>
                    <IonButton slot="end" size="default" type="submit" form="paymentInfoForm">
                      <IonIcon slot="start" icon={card}/>
                      <IonText className="ion-hide-sm-down">Ödeme Yap</IonText>
                      <IonText className="ion-hide-sm-up">Öde</IonText>
                    </IonButton>
                  </IonItem>
                </IonCol>
              </IonRow>
            </IonGrid>
          </div>
        </Carousel>
      </IonContent>
    </IonPage>
  );
};

export default AnneBebekPaketi;
